import angular from 'angular';
import providerQuickForms from './providerQuickForms';
import './style.scss';

export default angular
  .module('components.providerQuickForms', [])
  .component('providerQuickForms', providerQuickForms).name;
